import * as React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

interface IProps {
    children?: React.ReactNode;
    className?: string;
}

export function FormRow({ children, className }: IProps): JSX.Element {
    return <div className={cn(styles.row, className)}>{children}</div>;
}
